import { AnalyticsClient } from "@lib/analytics/AnalyticsClient";
import type { ReactNode } from "react";
import { useTryAndBuyContext } from "../context";
import { getReason } from "./utils/getReason";

type Props = {
    onClose: () => void;
    children: (onClose: () => void) => ReactNode;
    productId: string;
};

export const CloseWithAnalyticsProvider = ({ children, onClose, productId }: Props) => {
    const { isSuccess, sku, selectedStore, hasStoresWithAvailability } = useTryAndBuyContext();

    const onCloseWithAnalytics = () => {
        if (!isSuccess) {
            AnalyticsClient.tryAndBuyDropOff({
                productId,
                reason: getReason({ sku, selectedStore, hasStoresWithAvailability }),
            });
        }

        onClose();
    };

    return children(onCloseWithAnalytics);
};
